import {BasePanelPage} from "../../panels/BasePanelPage";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {subscribeFlowState} from "../../../inline-subscription/SubscribeFlowState";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {apiChangeSubscription, SubscriptionApplyPolicy} from "../../../../../client/state/SubscriptionStore";
import {Messages} from "../../../../Messages";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {LabeledCheckbox} from "../../../../ui/Checkbox";
import {MerchantCheckbox} from "../../../../widget/ui/MerchantCheckbox";
import {subscribePlanController} from "../../../inline-subscription/SubscribePlanController";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {addressController} from "../../../inline-subscription/AddressController";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {PaywallToast} from "../../../PaywallToast";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PaywallConstants";


export async function updateSubscription(subscriptionDetails) {
    subscriptionDetails = {
        subscriptionId: iFrameUserDataService.getActiveSubscription().id,
        ...subscriptionDetails,
    };
    LoadingSpinner.show();
    let subscription = null;
    try {
        subscription = await apiChangeSubscription(subscriptionDetails);
    } catch (error) {
        PaywallToast.showError(error.message);
    } finally {
        LoadingSpinner.hide();
    }

    if (!subscription || !subscription.isActive()) {
        console.warn("Subscribe error: ", Messages.subscribeFailed);
        return;
    }
    Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess);
}

export class InlineUserDashboardSubscriptionChangeConfirmPanelStyle extends InlineUserDashboardPanelStyle {
    @styleRule
    checkbox = {
        color: "inherit",
        fontSize: "inherit",
        marginBottom: 8,
    };

    @styleRule
    lineSeparator = {
        width: "100%",
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
        margin: "12px 0",
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 8,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };
}

@registerStyle(InlineUserDashboardSubscriptionChangeConfirmPanelStyle)
export class InlineUserDashboardSubscriptionChangeConfirmPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewChange,
        }
    }

    render() {
        const {selectedSubscriptionOffer, applyPolicy, discountCode} = subscribeFlowState.getSubscriptionInfo();
        const discountInfo = subscribeFlowState.getDiscountInfo(selectedSubscriptionOffer);
        const instantPayInfo = subscribeFlowState.getDiscountInfoOnInstantChangePolicy(selectedSubscriptionOffer);
        const nextCyclePayInfo = subscribeFlowState.getDiscountInfo(selectedSubscriptionOffer);
        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        const {styleSheet} = this;
        const paidUntil = activeSubscription.getPaidUntil();
        const nextBillingDate = activeSubscription.getNextBillingDate();

        const paymentInfoMessageArgs = [
            selectedSubscriptionOffer.formatPrice(nextCyclePayInfo.finalPrice),
            selectedSubscriptionOffer.getCycleDuration(),
            nextBillingDate.format("MMM DD, YYYY")
        ];
        const updatePaymentInfo = applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE ? [
                Messages.updateAtEndCyclePaymentInfo(...paymentInfoMessageArgs),
                selectedSubscriptionOffer !== activeSubscription.getOffer() ? Messages.updateAtEndCycleChangeOffer : ""].join("")
            : Messages.updateInstantlyPaymentInfo(
                selectedSubscriptionOffer.formatPrice(instantPayInfo.finalPrice),
                ...paymentInfoMessageArgs);

        let checkboxElement = null;
        if (instantPayInfo.finalPrice !== nextCyclePayInfo.finalPrice) {
            checkboxElement = <LabeledCheckbox className={styleSheet.checkbox}
                                               onChange={enabled => {
                                                   subscribePlanController.applyPolicy = enabled ? SubscriptionApplyPolicy.NEXT_BILLING_CYCLE :
                                                       SubscriptionApplyPolicy.INSTANTLY;
                                                   this.redraw();
                                               }}
                                               CheckboxClass={MerchantCheckbox} initialValue={applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE}
                                               label={Messages.updateAtEndCycleCheckbox(paidUntil.format("MMM DD, YYYY"))}/>;
        }

        return [
            selectedSubscriptionOffer !== activeSubscription.getOffer() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <MessageElement message={Messages.updateSubscriptionPlanDescription(selectedSubscriptionOffer.getName(), selectedSubscriptionOffer.formatPrice(nextCyclePayInfo.finalPrice))}/>
                    <div className={styleSheet.lineSeparator}/>
                </div> : null,
            selectedSubscriptionOffer.shouldCollectAddress() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.address}</div>
                    <MessageElement message={Messages.updateSubscriptionPlanAddress(addressController.selectedAddress.toString())}/>
                    {selectedSubscriptionOffer !== activeSubscription.getOffer() ? <div className={styleSheet.lineSeparator}/> : null}
                </div> : null,
            selectedSubscriptionOffer !== activeSubscription.getOffer() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.payment}</div>
                    {checkboxElement}
                    <MessageElement message={updatePaymentInfo}/>
                </div> : null,
            <MerchantButton label={Messages.changeSubscription} className={styleSheet.button}
                            onClick={() => updateSubscription({
                                applyPolicy,
                                recurringOfferId: selectedSubscriptionOffer.id,
                                userAddressId: addressController.selectedAddress.id,
                                discountCode: discountInfo.discountValue ? discountCode : null,
                            })}/>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => Router.back()}>
                    {Messages.back}
                </div>
            </div>
        ];
    }
}
